@if (images.length) {
<section id="interior-design-gallery">
  <div class="filter-thumbnail-container">
    @if (interiorContentType === interiorContentTypes.Designs || interiorContentType === interiorContentTypes.CameraAngle) {
    <div class="design-filters">
      <div class="field">
        @if (interiorContentType !== interiorContentTypes.CameraAngle) {
        <label>{{roomTypeLabel}}:</label>
        }
        <select [ngModel]="selectedRoomType" (ngModelChange)="handleRoomTypeChange($event)">
          <option [value]="''">--</option>
          @for (roomType of roomTypes; track roomType) {
          <option [value]="roomType">{{ roomType | capitalizeFirstLetter }}</option>
          }
        </select>
      </div>
      @if (interiorContentType === interiorContentTypes.Designs) {
      <div class="field">
        <label>Design Type:</label>
        <select [ngModel]="selectedDesignType" (ngModelChange)="handleDesignTypeChange($event)" [disabled]="!selectedRoomType">
          <option [value]="''">--</option>
          @for (designType of designTypes; track designType) {
          <option [value]="designType">{{ designType | capitalizeFirstLetter }}</option>
          }
        </select>
      </div>
      }
    </div>
    }
    @if (selectedRoomType || interiorContentType !== interiorContentTypes.Designs) {
    <div #designThumbnailContainer class="design-thumbnails-container" (keydown)="handleArrowKeys($event)" tabindex="0">
      <div class="design-thumbnails">
        @for (image of filteredImages; track trackById($index, image)) {
        <div class="design-thumbnail">
          <img [src]="image.PrimaryThumbnailUrl" [ngClass]="{'selected': image.Id === selectedImage?.Id, 'current': image.Id === currentImage?.Id && image.Id !== selectedImage?.Id}" (click)="handleImageChange(image)" />
          @if (image.Id === selectedImage?.Id) {
          <svg-helper svgName="check"></svg-helper>
          }
        </div>
        }
      </div>
    </div>
    }
  </div>
  <div class="design-viewer-container">
    @if (!displayOnly && showSelectedDesigns) {
    @if (interiorContentType === interiorContentTypes.Designs) {
    <div class="selected-designs-container">
      @if (allFPRoomsDesignSelections.length) {
      <p>Selected Furniture:</p>
      }
      @if (allFPRoomsDesignSelections.length) {
      <div class="selected-designs-slider">
        <div class="selected-designs">
          @for (image of allFPRoomsDesignSelections; track trackById($index, image)) {
          <div class="selected-design">
            <img [src]="image.PrimaryThumbnailUrl" (click)="handleModalImageSelect(image)" />
          </div>
          }
        </div>
      </div>
      }
    </div>
    }
    }
    <div class="image-viewer-container">
      @if (interiorContentType === interiorContentTypes.Designs && !selectedRoomType) {
      <div class="room-selection-message">
        <p>Select a room type to view your options.</p>
      </div>
      }
      @if (currentImage && ((selectedRoomType && interiorContentType === interiorContentTypes.Designs) || interiorContentType !== interiorContentTypes.Designs)) {
      <div class="current-image-banner">
        <p>{{currentImage.ImageDisplayName | capitalizeFirstLetter}}</p>
      </div>
      }
      @if ((interiorContentType === interiorContentTypes.Designs && selectedRoomType) || interiorContentType !== interiorContentTypes.Designs) {
      <div class="selected-image-container">
        <img [src]="selectedImageType === imageTypes.GreyBox || selectedImageType === imageTypes.Standard ? currentImage.PrimaryUrl : currentImage.SecondaryUrl" />
      </div>
      }
    </div>
    <div class="design-controls-container">
      @if (interiorContentType === interiorContentTypes.Designs && selectedRoomType) {
      <div class="design-image-disclaimer">
        @if (selectedImageType === imageTypes.GreyBox) {
        <p>This view only shows the pieces included and not the arrangement.</p>
        }
        @if (selectedImageType === imageTypes.Staged) {
        <p>This view displays furniture pieces staged within a default environment; however, your own interior specifications will be applied in the final rendering.</p>
        }
      </div>
      }
      @if (currentImage.SecondaryUrl && selectedRoomType) {
      <div class="design-toggle-container">
        <button (click)="handleToggleImageType(imageTypes.GreyBox)" [ngClass]="{'selected' : selectedImageType === imageTypes.GreyBox}">Furniture Only</button>
        <button (click)="handleToggleImageType(imageTypes.Staged)" [ngClass]="{'selected' : selectedImageType === imageTypes.Staged}">Fully Staged</button>
      </div>
      }
      @if (!displayOnly) {
      @if (currentImage && interiorContentType !== interiorContentTypes.CameraAngle
      && (interiorContentType !== interiorContentTypes.Designs || selectedRoomType)) {
      @if(interiorContentType === interiorContentTypes.Environment) {
      <div class="design-toggle-container">
        <button (click)="handleToggleImageType(imageTypes.Standard)" [ngClass]="{'selected' : selectedImageType === imageTypes.Standard}">Standard</button>
        <button (click)="handleToggleImageType(imageTypes.Soft)" [ngClass]="{'selected' : selectedImageType === imageTypes.Soft}">Soft</button>
      </div>
      }
      <button class="btn"
              [ngClass]="{'standard-positive': selectedImage?.Id !== currentImage?.Id, 'priority-positive' : selectedImage?.Id === currentImage?.Id}"
              (click)="handleImageSelect()">{{selectedImage?.Id === currentImage?.Id ? selectButtonLabel + ' Selected' : 'Select ' + selectButtonLabel}}</button>
      }
      @if (showNextButton) {
      <button class="btn standard-positive next-accordion-btn" (click)="handleOpenNextAccordion()" [disabled]="isNextBtnDisabled">Next</button>
      }
      }
    </div>
  </div>
</section>
}
@if (selectedModalDesignImage) {
<modal class="selected-design-modal" (close)="handleModalClose()">
  <div class="selected-design-modal-content">
    <h3>{{selectedModalDesignImage.ImageDisplayName}}</h3>
    <div class="selected-design-modal-image-container">
      <img [src]="selectedModalDesignImage?.PrimaryUrl" />
    </div>
  </div>
</modal>
}